<script setup lang="ts">
import { colors } from '@pkg/config/tailwind/colors';
import LocationIcon from '@pkg/cms-icons/icons/Location2_Icon.svg';
import MapStatic from '../../MapStatic.vue';
import CollapsibleSection from '~/app/components/base/CollapsibleSection.vue';
import { MAP_DIMENSIONS } from '~/app/types/mapTypes';
import type { MapData } from '~/app/types/mapTypes';

const props = defineProps<{
  mapData: MapData;
}>();

const device = useDevice();
const isTablet = computed(() => device.isTablet);
const isSectionOpen = ref(false);
const getCollapsibleState = (isOpen: boolean) => (isSectionOpen.value = isOpen);

const mapCoordinates = computed(() => {
  if (props.mapData.coordinates?.latitude && props.mapData.coordinates?.longitude) {
    return `${props.mapData.coordinates.latitude},${props.mapData.coordinates.longitude}`;
  }
  return null;
});

const iconColor = colors().primary['20'].replace('#', '0x');
const marker = computed(() =>
  mapCoordinates.value
    ? `markers=color:${iconColor}|${encodeURIComponent(mapCoordinates.value)}`
    : '',
);
const size = computed(() => isTablet.value ? MAP_DIMENSIONS.LARGE : MAP_DIMENSIONS.SMALL);
const style = 'style=feature:all|element:all|saturation:-100';

</script>

<template>
  <div>
    <hr class="s-divider"></hr>
    <CollapsibleSection v-if="mapData.title && mapData.address" :title="mapData.title" @toggle-collapsible="getCollapsibleState" />
    <p v-if="isSectionOpen && mapData.address" class="flex items-start gap-8 pt-8">
      <img :src="LocationIcon" alt="Location icon" class="pt-4">
      <span>{{ mapData.address }}</span>
    </p>
  </div>

  <div v-if="isSectionOpen">
    <MapStatic
      v-if="mapData.coordinates"
      :marker="marker"
      :size="size"
      :style="style"
      :zoom="15"
      :map-data="mapData"
      styles-class="map"
      alt="Map"
    />
  </div>
</template>

<style scoped>
.map {
  margin-top: theme('spacing.16');
  cursor: pointer;
  transition: opacity 0.2s ease;
  border-radius: 15px;
}
</style>
